<twc-popup caption="{{titleKey | translate}}" type="primary" [width]="'xl'">

    <twc-popup-content>
        <div class="twc-d-flex justify-space-between">
            <div>
                <button class="twc-button twc-button-secondary twc-button-icon" *ngIf="isEnabledGoBack()"
                    (click)="popupFileBrowserService.goBack()">
                    <twc-icon shape="acc-left" [size]="32"></twc-icon>
                </button>
                <span class="twc-ml-2">{{popupFileBrowserService.breadcrumb}}</span>
            </div>
            <twc-search (cleared)="popupFileBrowserService.filter()">
                <input class="twc-nofocus" twcSearchInput [placeholder]="'TAB_LAYERS.FILTER_LABEL' | translate"
                    [(ngModel)]="popupFileBrowserService.searchText" (input)="popupFileBrowserService.filter()">
            </twc-search>
        </div>

        <div class="list-container twc-mt-2 twc-d-flex flex-direction-column">
            <twc-list *ngIf="!popupFileBrowserService.isLoading; else loaderFileBrowser" class="height-100">

                <div class="empty-folder-message" *ngIf="!popupFileBrowserService.fileList?.length; else fileList">
                    {{'FILE_BROWSER.EMPTY' | translate}}
                </div>

                <ng-template #fileList>
                    <twc-list-item *ngFor="let file of popupFileBrowserService.visibleFileList"
                        (click)="popupFileBrowserService.openDirectory(file)">
                        <div class="twc-list-item-col-2 twc-d-flex align-center">
                            <twc-icon [shape]="getIcon(file)" [size]="32"></twc-icon>
                            <div class="field-name"> {{ file?.nameReplaced ?? file?.name }} </div>
                            <div class="field-size" *ngIf="showFileSize(file)"> {{ file.size | bytes }}</div>
                            <div class="field-type" *ngIf="showFileType(file)">
                                {{ getFileType(file) | translate }}
                            </div>
                        </div>
                        <div class="twc-list-item-col-3 buttons-container twc-d-flex align-center">
                            <twc-loader *ngIf="popupFileBrowserService.downloadingFile === file"
                                size="tiny"></twc-loader>
                            <button class="twc-button twc-button-link twc-button-icon" *ngIf="showDownloadButton(file)"
                                [disabled]="popupFileBrowserService.downloadingFile"
                                (click)="popupFileBrowserService.download(file, $event)">
                                <twc-icon shape="download" [size]="32"></twc-icon>
                            </button>
                            <button class="twc-button twc-button-link twc-button-icon" *ngIf="showDeleteButton(file)"
                                [disabled]="isDeleteButtonDisabled()"
                                (click)="popupFileBrowserService.remove(file, $event)">
                                <twc-icon shape="delete" [size]="32"></twc-icon>
                            </button>
                        </div>
                    </twc-list-item>
                </ng-template>
            </twc-list>

            <div class="width-100 twc-mt-2" (click)="popupFileBrowserService.nextPage()">
                <button *ngIf="popupFileBrowserService.existNextPage" class="twc-button twc-button-link float-right">{{
                    'FILE_BROWSER.LOAD_MORE' | translate }}</button>
            </div>
            <!-- Loader -->
            <ng-template #loaderFileBrowser>
                <div class="twc-d-flex align-center justify-content-center loader-container">
                    <twc-loader size="large"></twc-loader>
                </div>
            </ng-template>

        </div>

    </twc-popup-content>

</twc-popup>